import BrandBadge from "@tSurya/Components/BrandBadge";
import React from "react";
import styled from "styled-components";

interface PrintBrandBadgeProps {
    brandName?: string;
}

const NativeBadge = styled.div`
    width: 96px;

    svg {
        width: 96px;
        height: auto;
        display: block;
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
    }
`;

const MgbwBadge = styled.div`
    width: 96px;
    height: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background: #f2f2f3;
    color: #333132;
    font-family: sans-serif;
    font-size: 9px;
    font-weight: 400;
    line-height: 0.95;
    letter-spacing: 0;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
`;

const MgbwWordmark = styled.div`
    width: max-content;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    span:last-child {
        margin-left: 9px;
    }
`;

const PrintBrandBadge: React.FC<PrintBrandBadgeProps> = ({ brandName }) => {
    const normalizedBrandName = (brandName ?? "").toLowerCase().replace(/\s+/g, "");

    if (normalizedBrandName === "mgbw" || normalizedBrandName === "mg+bw") {
        return (
            <MgbwBadge>
                <MgbwWordmark>
                    <span>Mitchell Gold</span>
                    <span>+Bob Williams</span>
                </MgbwWordmark>
            </MgbwBadge>
        );
    }

    return (
        <NativeBadge>
            <BrandBadge brandName={brandName} />
        </NativeBadge>
    );
};

export default PrintBrandBadge;
